'use strict';

import roles from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        role: {},
        roles: []
    },
    getters: {
        getRole: (state) => state.role,
        getRoles: (state) => state.roles
    },
    mutations: {
        SET_ROLE(state, value) {
            state.role = value;
        },
        SET_ROLES(state, value) {
            state.roles = value;
        },
        CLEAR_STATE(state) {
            state.role = {};
            state.roles = [];
        }
    },
    actions: {
        fetchRoles(context, payload) {
            let { config } = payload || {};
            return new Promise((resolve, reject) => {
                roles
                    .getData({ to: '/cms-roles', config })
                    .then((response) => {
                        // console.log(response);

                        Object.values(response.data).map((key, index) => {
                            response.data[index].is_active = key.status == 'ACTIVE' ? true : false;
                        });
                        context.commit('SET_ROLES', response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_ROLES', []);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        findRole(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                roles
                    .getData({ to: `/cms-roles/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        response.data.is_active = response.data.status == 'ACTIVE' ? true : false;
                        context.commit('SET_ROLE', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_ROLE', {});
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        addRole(context, payload) {
            let { data, config } = payload || {};
            return new Promise((resolve, reject) => {
                roles
                    .postData({ to: '/cms-roles', data, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        updateRole(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                roles
                    .putData({ to: `/cms-roles/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        // context.commit('permissions/SET_USER_ACTION_KEYS', config.params.permissions_raw, { root: true });
                        // context.commit('permissions/SET_MODULE_COUNT', config.count, { root: true });
                        context.commit('SET_ROLE', response.data);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        deleteRole(context, payload) {
            let { id, config } = payload || {};
            return new Promise((resolve, reject) => {
                roles
                    .deleteData({ to: `/cms-roles/${id}`, config })
                    .then((response) => {
                        // console.log(response);
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
